'use client';

import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { LoadingBall } from '@depop/web-ui-kit/LoadingBall';

import { Table } from '@/components/AdminToolbox/components/Table';
import { useShopByUsername } from '@/modules/shop/hooks/useShopByUsername';

export function ShopInfo() {
  const { data, isPending: shopPending } = useShopByUsername();
  const shop = data?.data;

  if (shopPending) {
    return <LoadingBall />;
  }

  if (!shop) {
    return <Body variant="sm-regular">Failed to fetch shop data</Body>;
  }

  return (
    <div>
      <Table
        rows={{
          'Shop Id': shop.id,
          'Shop Username': shop.username,
          Verified: shop.verified,
        }}
      />
    </div>
  );
}
